export enum IElfsightDynamicSourceType {
  /* Used to map BE OTA types to Elfsight types

  There are types returned from BE which are not yet supported by Elfsight, e.g. Wunderflats, Homelike
  These will be excluded from this list until Elfsight supports them.

  This list comes from Elfsight but we don't have OTAs yet for all of these sources.
  When a new, Elfsight-supported OTA is added to the BE (https://gitlab.com/limehome/core-engine/properties-api/-/blob/develop/src/common/enums/public-ota-type.enum.ts),
  please check that the key name in this enum matches the exact OTA type coming from the backend 
  */

  airbnb = 'airbnb',
  ali_express = 'ali-express',
  amazon = 'amazon',
  angi = 'angi',
  apple_app_store = 'apple-app-store',
  avvo = 'avvo',
  bbb = 'bbb',
  booking_com = 'booking',
  capterra = 'capterra',
  dealer_rater = 'dealer-rater',
  ebay = 'ebay',
  ed_munds = 'ed-munds',
  etsy = 'etsy',
  expedia = 'expedia',
  facebook = 'facebook',
  findlaw = 'findlaw',
  g2 = 'g2',
  google = 'google',
  google_customer = 'google-customer',
  google_play_store = 'google-play-store',
  healthgrades = 'healthgrades',
  homeadvisor = 'homeadvisor',
  hotels = 'hotels',
  houzz = 'houzz',
  lawyers = 'lawyers',
  martindale = 'martindale',
  open_table = 'open-table',
  producthunt = 'producthunt',
  product_review = 'productreview',
  thumbtack = 'thumbtack',
  trip_advisor = 'trip-advisor',
  trusted_shops = 'trustedshops',
  vrbo = 'vrbo',
  walmart = 'walmart',
  yell = 'yell',
  yellow_pages = 'yellowpages',
  yelp = 'yelp',
  zillow = 'zillow',
  zomato = 'zomato'
}
